import { render, staticRenderFns } from "./WebPhoneCallHistory.vue?vue&type=template&id=6545db54&scoped=true"
import script from "./WebPhoneCallHistory.vue?vue&type=script&lang=js"
export * from "./WebPhoneCallHistory.vue?vue&type=script&lang=js"
import style0 from "./WebPhoneCallHistory.vue?vue&type=style&index=0&id=6545db54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6545db54",
  null
  
)

export default component.exports